import React from 'react';

import { WorkflowRunCommandName } from '@dashboard/generated/wp/platform';

import BaseCommandButton from './BaseCommandButton';

type Props = {
  workflowRunId: string;
};

export default function WakeupWorkflowRunButton({ workflowRunId }: Props) {
  return (
    <BaseCommandButton
      workflowRunId={workflowRunId}
      commandName={WorkflowRunCommandName.WakeUp}
      title="Skip delay?"
      description="Skipping the delay will fast-forward the delay and continue to the next step in the workflow."
      buttonText="Skip delay"
      confirmButtonLabel="Yes, skip delay"
    />
  );
}
